import { Directive, ElementRef, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { Subscription } from 'rxjs';
import { PageHeaderComponent } from '../../../page-header.component';

@Directive({
    standalone: true,
    selector: '[pageHeaderMeganavContentArea]'
})
export class PageHeaderMaganavContentAreaDirective implements OnInit, OnDestroy {
    /**
     * Toggle id entry to catch events
     */
    @Input()
    toggleClassBy?: NToggle.TId;

    /**
     * Subscription
     */
    private subscription!: Subscription;

    private elementRef = inject(ElementRef);

    private toggleService = inject(ToggleService);

    private readonly pageHeaderComponent = inject(PageHeaderComponent);

    /**
     * Initialise
     */
    ngOnInit(): void {
        // scroll wrapper back to top when we openinig
        if (this.toggleClassBy) {
            this.subscription = this.toggleService.getItem(this.toggleClassBy).state.subscribe(visible => {
                this.pageHeaderComponent.toggleCmsNode(this.elementRef.nativeElement, visible);
            });
        }
    }

    /**
     * Cleanup
     */
    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        this.pageHeaderComponent.toggleCmsNode(this.elementRef.nativeElement, false);
    }
}
